import { WorldMap } from '../maps/WorldMap';
import type { LocationData, MapPropertyTooltipData } from '../maps/WorldMap';

interface MapSectionProps {
  locations: LocationData[];
  height?: number;
  onPropertyViewDetails?: (property: MapPropertyTooltipData) => void;
}

export const MapSection = ({
  locations,
  height,
  onPropertyViewDetails,
}: MapSectionProps) => {
  return (
    <div className="map-container">
      <WorldMap
        locations={locations}
        height={height}
        onPropertyViewDetails={onPropertyViewDetails}
      />
    </div>
  );
};
